import { IGroupStep } from '../../../interface/concretes/group-step.interface';
import { Step } from './step.model';

export class GroupStep implements IGroupStep {
  private _steps: Step[];

  constructor(steps: Step[]) {
    this._steps = steps;
  }

  get steps(): Step[] {
    return this._steps;
  }

  set steps(value: Step[]) {
    this._steps = value;
  }
}
